/* tslint:disable */
/* eslint-disable */
export enum NotificationPriority {
  $0 = 0,
  $100 = 100,
  $1000 = 1000,
  $10000 = 10000,
  $100000 = 100000
}
